import { unescapeMarkdownLinkText } from '#pplx/frontend/common/markdownTitle.js';
import { LINK_TRANSFORMER } from '#pplx/frontend/composer-sdk/internal/link/linkTransformer.js';
import { unescapeMarkdownLinkTitle } from '#pplx/frontend/composer-sdk/lexical/utils/getMentionLinkMarkdown.js';
import { $createLinkNode } from '@lexical/link';
import { $createParagraphNode, $createTextNode, $getRoot } from 'lexical';
/**
 * Converts a markdown string to Lexical nodes, supporting only link syntax.
 * This is a simplified version of $convertFromMarkdownString from @lexical/markdown.
 */
export function convertFromMarkdownStringLinksOnly(markdown, node) {
    const root = node ?? $getRoot();
    root.clear();
    const lines = markdown.split('\n');
    for (const line of lines) {
        const paragraph = $createParagraphNode();
        processLineForLinks(line, paragraph);
        root.append(paragraph);
    }
    // Move selection to the start
    root.selectStart();
}
/**
 * Process a single line of text and convert markdown links to LinkNodes.
 * This is a simplified version of the processLineForLinks from @lexical/markdown.
 * It only supports links and does not support other markdown features.
 */
function processLineForLinks(text, paragraph) {
    const importRegExp = LINK_TRANSFORMER.importRegExp;
    if (!importRegExp) {
        paragraph.append($createTextNode(text));
        return;
    }
    let lastIndex = 0;
    // Use a global version of the regex to find all matches
    const globalRegExp = new RegExp(importRegExp.source, 'g');
    let match;
    while ((match = globalRegExp.exec(text)) !== null) {
        // Add text before the match
        if (match.index > lastIndex) {
            const beforeText = text.slice(lastIndex, match.index);
            paragraph.append($createTextNode(beforeText));
        }
        // Create the link node
        const [fullMatch, linkText, linkUrl, linkTitle] = match;
        if (linkUrl) {
            const linkNode = $createLinkNode(linkUrl, {
                title: linkTitle ? unescapeMarkdownLinkTitle(linkTitle) : undefined,
            });
            linkNode.append($createTextNode(linkText ? unescapeMarkdownLinkText(linkText) : linkUrl));
            paragraph.append(linkNode);
        }
        else {
            // If no URL, just add the text as-is
            paragraph.append($createTextNode(fullMatch));
        }
        lastIndex = match.index + fullMatch.length;
    }
    // Add remaining text after the last match (or all text if no matches)
    if (lastIndex < text.length) {
        paragraph.append($createTextNode(text.slice(lastIndex)));
    }
}
//# sourceMappingURL=linkMarkdown.js.map